import React from 'react'
import { ModalConfirm } from 'mailup-web-components'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'

const ModalDelete = ({
  state,
  name,
  show,
  handleCancel,
  handleConfirm,
  appendToDataMuTest,
  idABTest
}) => {
  const intl = useIntl()

  const getTitle = () => {
    return state
      ? 'Load.AbTest.ModalDeleteTestRunningConfirmTitleNew'
      : 'Load.AbTest.ModalDeleteConfirmTitleNew'
  }

  const getParagraph = () => {
    return [1, 2].includes(state)
      ? 'Load.AbTest.ModalDeleteTestRunningConfirmDescrNew'
      : 'Load.AbTest.ModalDeleteConfirmDescrNew'
  }

  return (
    <ModalConfirm
      show={show}
      title={intl.formatMessage(
        {
          id: getTitle()
        },
        {
          nome: name
        }
      )}
      message={intl.formatMessage(
        {
          id: getParagraph()
        },
        {
          nome: name
        }
      )}
      stringCancel={intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
      stringConfirm={intl.formatMessage({ id: 'Load.MailupCommon.Delete' })}
      onClickCancel={handleCancel}
      onClickConfirm={handleConfirm}
      variant='delete'
      data-mu-test={`modal-delete-sending-${appendToDataMuTest}`}
    />
  )
}

ModalDelete.propTypes = {
  show: PropTypes.bool,
  handleCancel: PropTypes.func,
  handleConfirm: PropTypes.func,
  appendToDataMuTest: PropTypes.string,
  state: PropTypes.number,
  name: PropTypes.string,
  idABTest: PropTypes.number
}

export default ModalDelete
